var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgChartIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "64px",
    height: "64px",
    viewBox: "0 0 64 64",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Chart Icon") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Chart-Icon",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    fill: "#F3F3F3",
    x: 0,
    y: 0,
    width: 64,
    height: 64,
    rx: 8
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group-9",
    transform: "translate(14.000000, 16.000000)",
    stroke: "#263238",
    strokeWidth: 1.88235294
  }, /*#__PURE__*/React.createElement("path", {
    d: "M32.9411765,25.4115765 C32.9411765,26.4478118 32.0941176,27.2939294 31.0588235,27.2939294 L27.2941176,27.2939294 C26.2588235,27.2939294 25.4117647,26.4478118 25.4117647,25.4115765 L25.4117647,1.88216471 C25.4117647,0.846870588 26.2588235,-0.000188235294 27.2941176,-0.000188235294 L31.0588235,-0.000188235294 C32.0941176,-0.000188235294 32.9411765,0.846870588 32.9411765,1.88216471 L32.9411765,25.4115765 Z",
    id: "Stroke-1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.6470588,25.4115765 C21.6470588,26.4478118 20.8,27.2939294 19.7647059,27.2939294 L16,27.2939294 C14.9647059,27.2939294 14.1176471,26.4478118 14.1176471,25.4115765 L14.1176471,10.2219294 C14.1176471,9.18663529 14.9647059,8.33957647 16,8.33957647 L19.7647059,8.33957647 C20.8,8.33957647 21.6470588,9.18663529 21.6470588,10.2219294 L21.6470588,25.4115765 Z",
    id: "Stroke-3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.3529412,25.4115765 C10.3529412,26.4478118 9.50588235,27.2939294 8.47058824,27.2939294 L4.70588235,27.2939294 C3.67058824,27.2939294 2.82352941,26.4478118 2.82352941,25.4115765 L2.82352941,18.9541647 C2.82352941,17.9188706 3.67058824,17.0718118 4.70588235,17.0718118 L8.47058824,17.0718118 C9.50588235,17.0718118 10.3529412,17.9188706 10.3529412,18.9541647 L10.3529412,25.4115765 Z",
    id: "Stroke-5"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 3.67940972e-14,
    y1: 31.0504471,
    x2: 35.7647059,
    y2: 31.0504471,
    id: "Stroke-7",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChartIcon);
export default __webpack_public_path__ + "static/media/chart-icon.d66f98c9.svg";
export { ForwardRef as ReactComponent };